import React from "react";

type IProps = Omit<
  React.HTMLAttributes<HTMLParagraphElement>,
  "className" | "children"
> & {
  children: string;
};

export const TagContent: React.FC<IProps> = ({ children, ...props }) => (
  <span {...props} className="fs-tag__content">
    {children}
  </span>
);
